module.exports = __webpack_public_path__ + "img/queue-ilustration.0aa3f529.svg";